export default {
  methods: {
    //reduce faster with for map
    newReduce(arr, prop, opt = null) {
      let res = 0;
      for (let i = 0; i < arr.length; i++) {
        if (opt) {
          arr[i][prop]
            ? (res = res += arr[i][prop])
            : (res = res += arr[i][opt]);
        } else {
          res = res += arr[i][prop];
        }
      }
      return res;
    }
  }
};
